import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const searchPlatformViewAccessControl: DomainAccessControlConfig = {
  permissions: Permission.SearchPlatformView,
  warehouseFeatureToggles: [FeatureToggle.searchPlatform],
  minICPlatformVersion: ICPlatformVersion.r2026_02_0,
}

export const searchPlatformModifyAccessControl: DomainAccessControlConfig = {
  permissions: Permission.SearchPlatformModify,
  warehouseFeatureToggles: [FeatureToggle.searchPlatform],
  minICPlatformVersion: ICPlatformVersion.r2026_02_0,
}
